"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleLogoutRedirect = exports.LogoutLink = void 0;
const router_1 = require("next/router");
const react_1 = __importStar(require("react"));
const LogoutLink_helpers_1 = require("./LogoutLink.helpers");
/**
 * A React component that renders a link to identity-ui for logout.
 * Accepts an optional destination prop to use as the destination
 * if the user chooses to log back in. Defaults to the window's current pathname with query string.
 * @param props Props
 * @param props.children Children to be rendered
 * @param props.destination _Optional_. Absolute or relative URL to use as the destination
 * if the user chooses to log back in. Defaults to the window's current pathname with query string.
 * @param props.Component _Optional_. The Component to render with an `href` prop.
 * @deprecated Use `Link` with href to `/identity/logout` instead.
 * Defaults to an anchor tag.
 * @returns A React component
 */
const LogoutLink = ({ children, destination, Component = 'a', }) => {
    const { asPath, pathname, basePath, isReady } = (0, router_1.useRouter)();
    // asPath includes the existing query string,
    // but shouldn't be used until isReady is true,
    // and isReady should only be used inside useEffect.
    // neither includes the basepath if enabled.
    // see https://nextjs.org/docs/api-reference/next/router#router-object
    const currentFullPath = destination ?? `${basePath}${pathname}`;
    const [href, setHref] = (0, react_1.useState)(() => (0, LogoutLink_helpers_1.generateLogoutUrl)(currentFullPath));
    // we should update the href to use `asPath` when possible
    // so existing query params are preserved
    // we also need to update the destination param
    // if the user navigates to a new page
    (0, react_1.useEffect)(() => {
        // if the consumer provided a destination,
        // we should always use it instead
        if (destination === undefined) {
            const updatedPathname = isReady
                ? `${basePath}${asPath}`
                : `${basePath}${pathname}`;
            setHref((0, LogoutLink_helpers_1.generateLogoutUrl)(updatedPathname));
        }
    }, [destination, basePath, isReady, asPath, pathname]);
    return react_1.default.createElement(Component, { href: href }, children);
};
exports.LogoutLink = LogoutLink;
/**
 * A function to imperatively redirect users to identity-ui for logout.
 * Prefer using `<LogoutLink>` when possible.
 * @param destination optional absolute or relative URL to use as the destination
 * if the user chooses to log back in. Defaults to the window's current location.
 */
const handleLogoutRedirect = (destination) => {
    /* istanbul ignore if */
    if (typeof window === 'undefined') {
        throw new Error('handleLogoutRedirect must be run on the client side');
    }
    const currentPathname = `${window.location.pathname}${window.location.search}`;
    const redirectUrl = (0, LogoutLink_helpers_1.generateLogoutUrl)(destination ?? currentPathname);
    window.location.assign(redirectUrl);
};
exports.handleLogoutRedirect = handleLogoutRedirect;
